// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ec3fe56a","977":"035a6610"}[chunkId] + ".chunk.js";
};